var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"splash-container",style:({height: _vm.innerHeight + 'px'})},[_c('TourialLogo')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }